export default __webpack_public_path__ + "static/media/Google_play.fa0ec55e.svg";